<div>
  <div class="modal-header modalHeaderDefault" >
    <h6 class="modal-title">{{ "Blocking Details"}}</h6>
    <span aria-label="Close" class="close" (click)="onNoClick()" matTooltip="Close">
      <mat-icon>clear</mat-icon>
    </span>
  </div>
  <br />

  <div style="padding-bottom: 5px; padding-left: 5px; padding-right: 5px">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="BlockingDate">
        <th mat-header-cell *matHeaderCellDef >
          {{ "mrd.performedOn" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.date}}</td>
      </ng-container>

      <ng-container matColumnDef="BlockStatus">
        <th mat-header-cell *matHeaderCellDef>
          {{ "mrd.status" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.status }}</td>
      </ng-container>

      <ng-container matColumnDef="BlockingBy">
        <th mat-header-cell *matHeaderCellDef>
          {{ "mrd.performedBy" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.user }}</td>
      </ng-container>

      <ng-container matColumnDef="BlockingReason">
        <th mat-header-cell *matHeaderCellDef>
          {{ "mrd.reason" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.reason }}</td>
      </ng-container>

      <ng-container matColumnDef="BlockingRemarks">
        <th mat-header-cell *matHeaderCellDef>
          {{ "mrd.remarks" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <span
            [matTooltip]="element.remarks"
            matTooltipPosition="above"
            [matTooltipDisabled]="!element.remarks || element.remarks.length <= 100"
            style="display: inline-block; max-width: 200px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
          >
            {{ element.remarks }}
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
